import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StyledHeader } from './styles';
import HeaderSection, { HeaderSectionPosition } from '../Header/Section';
import { StoreState } from '../../../reducers';
import { Api } from '../../../typings/api';
import { GalleryInfosState } from '../../Gallery/reducer';
import { MenuState } from '../reducer';
import Utils from '../../../utils';
import { MenuItem, MenuItemType } from '../../../typings/menu';
import UserAgentUtils from '../../../utils/userAgent';
import { DriveItemListOrigin } from '../../DriveItemListPage/constants';
import { AppType } from '../../App/reducer';

interface HeaderProps {
	driveItems?: Api.DriveFolderInfo[];
	galleryInfos: GalleryInfosState;
	menuManager: MenuState;
	dispatch: Dispatch<StoreState>;
	isShareable: boolean;
	isDownloadable: boolean;
	origin: string;
}

class Header extends React.Component<HeaderProps, {}> {
	filterMenuItems(menuItems: MenuItem[]): MenuItem[] {
		const { galleryInfos, origin, driveItems, isDownloadable, isShareable } = this.props;
		const hasDriveItems = driveItems !== undefined && driveItems.length > 0;

		if (menuItems) {
			return menuItems.filter((item) => {
				switch (item.type) {
					case MenuItemType.New:
						return UserAgentUtils.isOnline() || !Utils.isMaster(galleryInfos.config);
					case MenuItemType.Downloads:
					case MenuItemType.Updates:
					case MenuItemType.Parameters:
						return UserAgentUtils.isMobileApp;
					case MenuItemType.DownloadButton:
						return origin !== DriveItemListOrigin.Downloads && hasDriveItems && isDownloadable;
					case MenuItemType.ShareButton:
						return hasDriveItems && isShareable;
					case MenuItemType.DisplayButtons:
						return origin;
					case MenuItemType.Favorites:
						return origin !== DriveItemListOrigin.Favorites;
					default:
						return item;
				}
			});
		}
		return [];
	}

	render() {
		const { galleryInfos, driveItems, menuManager } = this.props;
		const { template } = galleryInfos;
		const { menuModes } = menuManager;

		return (
			<div>
			{ template && template.menu && menuModes &&
				<StyledHeader>
					<HeaderSection position={HeaderSectionPosition.Left} menuItems={this.filterMenuItems(menuModes.left)} driveItems={driveItems}/>
					<HeaderSection position={HeaderSectionPosition.Center} menuItems={this.filterMenuItems(menuModes.center)} driveItems={driveItems}/>
					<HeaderSection position={HeaderSectionPosition.Right} menuItems={this.filterMenuItems(menuModes.right)} driveItems={driveItems}/>
				</StyledHeader>}
			</div>
		);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos, menuManager, routerParamsHistory, authentication, appInfos } = state;
	const { sharedMethods } = galleryInfos.template;
	const { needCredentials } = authentication.userInfos;
	const { origin } = routerParamsHistory[routerParamsHistory.length - 1].params;
	const type = appInfos.type || AppType.Single;
	const isDownloadable = sharedMethods && sharedMethods.includes(Api.ShareMethod.Download);

	// Secured galleries can't share the root gallery
	const isSecure = Utils.isSecure(type, needCredentials);
	const isGalleryRoot = Utils.isGalleryRoot(routerParamsHistory[routerParamsHistory.length - 1]);
	const isShareable = sharedMethods && sharedMethods.includes(Api.ShareMethod.Share) && !(isGalleryRoot && isSecure);

	return { galleryInfos, menuManager, isShareable, isDownloadable, origin };
};

export default connect(mapStateToProps)(Header);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/index.tsx